import React, { useEffect, useMemo, useState } from 'react'
import ReactChart from 'react-apexcharts'
import { Card, Col, Row, Spinner } from 'react-bootstrap'
import DashboardRequestService from 'services/dashboard-request'

function ChartItem({ props, series, title }) {
  const total = series.reduce((a, b) =>  a + b)

  if (total == 0) {
    return <h4 style={{textAlign:"center"}}>Sem dados</h4>
  }

  return (
    <ReactChart 
      options={{
        labels: [
          'Acelerador 1',
          'Acelerador 2',
          'Acelerador 3',
          'Acelerador 4',
        ],
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 500,
          animateGradually: {
            enabled: true,
            delay: 150,
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350,
          },
        },
        title:{
          text:`Programa ${title}`
        }
      }}
      series={series}
      type="donut"
      {...props} 
      height={300}
    />
  )
}

const ChartParticipationIndex = ({ chartProps, fiscalYear }) => {
  const [loading, setLoading] = useState(false)
  const [acceleratorsData, setAcceleratorsData] = useState([]);

  const programs = useMemo(()=>{
    return fiscalYear.programs;
  },[fiscalYear]);

  useEffect(() => {
    function getData(){
      return new Promise(async (s,n)=>{
        try {
          let r = [];
          for (let i = 0; i < programs.length; i++) {
            const p = programs[i];

            let data = await DashboardRequestService
            .getAcceleratorParticipationIndex({
              params: {
                __fiscal_year_id: fiscalYear.id,
                __program_id: p.premium_id
              }
            })
            r.push({
              name: p.name,
              data: data.data
            });
          }
          s(r)
        } catch (error) {
          n(error);
        }
      });
    }

    function setLoad(){
      setAcceleratorsData(programs.map(a=>{
        return {name:a.name, data:[]};
      }))
      setLoading(true);
    }
    setLoad();
    getData().then((r)=>{
      // console.log("Índice de participação",r)
      setAcceleratorsData(r);
    }).catch().finally(()=>{
      setLoading(false);
    });
  }, [fiscalYear, programs]);

  const buildAcceleratorsData = (arr) => {
    return [1,2,3,4].map(num => getAcceleratorsTotal(arr, num))
  }

  const getAcceleratorsTotal = (arr, accelerator) => {
    let item = arr.filter(
      (a) => a.accelerator === accelerator
    )[0];
    if (item) return item.total;
    return 0;
  };

  return (
    <Col className="p-1 pb-2" xl="9" lg="12" md="12">
      <Card.Body className="shadow bg-white rounded h-100 w-100">
        <Row>
          <Col md="12">
            <span className="dashboard-card-h5 text-left">
              Índice de participação
            </span>
          </Col>
          <Col md="12">
            <hr></hr>
          </Col>
        </Row>
        <Row>
          {acceleratorsData.map((ad, key)=>{
            return (
              <Col key={key}>
                {loading ? (<div className='d-flex flex-column align-items-center justify-content-center'>
                  <Spinner className='text-h5' animation="border" />
                  <span className="mt-3 h4">Índice {ad.name}</span>
                </div>) : (<>
                  <ChartItem 
                    title={ad.name} 
                    series={buildAcceleratorsData(ad.data)}
                    {...chartProps} 
                  />
                </>)}
              </Col>
            );
          })}
        </Row>
      </Card.Body>
    </Col>
  )
}

export default ChartParticipationIndex